<template>
  <div class="login-box">
    <div class="sign-content">
      <p class="title">云快选商家后台系统</p>
      <el-form ref="loginForm" :rules="rules" :model="loginForm" class="login-form add-form" v-if="loginType === '1'">
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="ewmShow">
          <el-tab-pane label="短信验证码登录" name="second">
            <el-form-item>
              <el-input v-model.trim="loginFormCode.mobile" placeholder="请输入手机号">
                <div slot="prefix" class="mobile-icon">
                </div>
              </el-input>
            </el-form-item>
            <el-form-item prop="" label="">
              <div style="display: flex;justify-content: space-between">
                <el-input v-model.trim="loginFormCode.imageCode"  placeholder="请输入验证码"></el-input>
                <img @click="getImage" :src="imgSrc" class="codeImg" />
              </div>
            </el-form-item>
            <el-form-item>
              <div class="code-box">
                <el-input v-model.trim="loginFormCode.code" class="form-control code" placeholder="请输入验证码">
                  <div slot="prefix" class="yzm-icon">
                  </div>
                </el-input>
                <div class="get-code" @click="getCode" v-if="count <= 0">获取验证码</div>
                <div class="get-code" v-else>{{ count }}秒后重新获取</div>
              </div>
            </el-form-item>
            <div class="btn btn-success btn-block" @click="loginByCode">登录</div>
          </el-tab-pane>

          <el-tab-pane label="邮箱登录" name="first">
<!--            <div class="wx-code" v-if="activeName === 'first'">-->
<!--              <img v-if="qrUrl" :src="qrUrl" alt="" />-->
<!--            </div>-->
<!--            <p class="email-title">邮箱登录</p>-->
            <el-form-item>
              <el-input v-model.trim="loginForm.username" placeholder="请输入邮箱账号" >
                <div slot="prefix" class="email-icon">
                </div>
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="code-box">
                <el-input v-model.trim="loginForm.code" class="form-control code" placeholder="请输入验证码">
                  <div slot="prefix" class="yzm-icon">
                  </div>
                </el-input>
                <div class="get-code" @click="sendEmailCode" v-if="ewmCount <= 0">获取验证码</div>
                <div class="get-code" v-else>{{ ewmCount }}秒后重新获取</div>
              </div>
            </el-form-item>
            <el-form-item prop="" label="">
              <div style="display: flex;justify-content: space-between">
                <el-input v-model.trim="loginForm.imageCode"  placeholder="请输入验证码"></el-input>
                <img @click="getImage" :src="imgSrc" class="codeImg" />
              </div>
            </el-form-item>
            <div class="btn btn-success btn-block" @click="login">登录</div>
<!--            <div class="email-enter">返回？<span @click="backEwm">扫码登录</span></div>-->
          </el-tab-pane>

<!--          <div class="email-enter">海外商家？<span @click="emailEnter">去登录</span></div>-->
        </el-tabs>

<!--        <div v-else>-->
<!--        </div>-->

        <div class="visit-rules">
          <el-checkbox v-model="rulesCheck"></el-checkbox>
          <span class="rules-text" @click="rulesShow=true">我同意 - 《隐私协议》 并确认已阅读及明白上述声明，并同意此声明所概述的收集使用本人的个人资料，包括组委会发送展会相关内容的通知。</span>
        </div>
      </el-form>
    </div>

    <div class="sign-footer">
      <div class="footer-text">
        Copyright © 2018-2023 云快选 All Rights Reserved. <br>
      </div>
    </div>

    <div class="rules-mask" v-if="rulesShow">
      <div class="rules-body">
        <div class="close-box">
          <div class="rules-close" @click="rulesShow=false">X</div>
        </div>
        <div class="rules-content">
          <h2>隐私政策</h2>
          <p class="weigh-text">导言与公司介绍</p>
          <p>本隐私政策由INFORMAEXHIBITIONSPTE.LTD.和上海百文会展有限公司发布。本政策中出现的“主办方”、 “我们”或“我们的”等表述，系指上海百文会展有限公司。</p>
          <p>我们严肃对待数据和信息的隐私和保护问题，并承诺，对于任何和我们接触的客户、供应商、员工或任何其他社群，我们都将根据经营所在地国家的法律，负责任地处理该等个人信息。</p>
          <p>在您使用我们的产品和服务、浏览我们的网站（包括微信小程序）和联系企业时，我们将收集数据和信息。本隐私政策载明了我们对保护和维护个人信息隐私所采用的方法，并解释了我们所收集的数据类型、使用数据的方式、使用的法律依据，以及个人对数据所享有的权利。</p>
          <p class="underline-text">我们收集哪些信息</p>
          <p>本节规定了在您使用我们的产品和服务时我们将收集哪些个人信息，以及我们将从其他来源收集哪些其他个人信息。</p>
          <p>本隐私政策中，“个人信息”是指我们可以收集和使用的个人信息类型，具体包括以下信息：</p>
          <div class="queue-box">
            <p>● 联系信息，如姓名、电子邮箱地址、邮寄地址和电话号码</p>
            <p>● 教育背景、国籍和职业信息教育背景、国籍和职业信息</p>
            <p>● 用户名和密码</p>
            <p>● 支付信息，如信用卡或借记卡卡号或银行账户信息</p>
            <p>● 订单安全相关设备信息及其他反洗钱法律要求的必要信息</p>
            <p>● 用于线上展会简介和现场展会广告的处理图片</p>
            <p>● 所提交的评论、反馈、帖子和其他内容，包括问卷调查信息</p>
            <p>● 兴趣和适当情形下的同意营销的通讯偏好，包括感兴趣的商品、店铺、频道、直播间、内容（图文、短视频）进行收藏/添加/关注/分享/点赞操作</p>
            <p>● 定位信息，如通过移动应用提供的定位信息</p>
            <p>● 身份核实信息（如护照），以遵守某些国家的法定义务，并在要求时提供签证邀请函</p>
            <p>● 个人身份证号码和身份证件扫描件，以履行线下展会防疫和公共安全管理等法律义务（我们可能会在法律、行政法规规定的保留期限内，或必要期限内保留这些信息。我们也可能与政府机构共享该信息）</p>
            <p>● 网站、微信小程序和其他通讯使用信息，例如通过 Cookie 或其他跟踪技术获得的您使用我们网站和服务的信息和详细信息</p>
          </div>
          <p>上述个人信息涉及以下类别的人：</p>
          <div class="queue-box">
            <p>● 潜在客户、客户联系人、我们的服务和产品的订购人/订阅人和用户；</p>
            <p>● 展会的参观人员、赞助商、参展商和发言人；</p>
            <p>● 服务商和业务合作伙伴的联系人。</p>
          </div>

          <p class="underline-text">个人敏感信息</p>
          <p>如果收集或保存个人敏感信息，如有关财务状况、健康、宗教信仰或政治立场等方面的信息，我们通常需要征得您的明确同意。但某些有限的情况除外，例如在您发生意外事故时，我们将不会征得您的明确同意。如果发生上述情形，我们将确保您的隐私权受到保护。</p>
          <p class="underline-text">儿童个人信息</p>
          <p>我们向企业专业人员提供服务和产品。产品不针对年龄低于16周岁的儿童使用。我们不会在明知情况下向这个年龄人群的用户收集个人信息。如果我们知悉并收集了此类信息，我们保留删除此类信息的权利。</p>
          <p class="underline-text">商业信息</p>
          <p>如果您申请注册成为商家或其他存在额外身份认证要求的用户角色，您需主动向我们提供身份信息及/或企业相关信息（包括营业执照副本、主营产品、业务范围、经营模式和规模、采购需求等），用于您身份及其他用户角色获取资格的核验、登记、公示，为您提供我们承诺的服务，促成贸易合作的达成及其他我们明确告知的目的。</p>

          <p class="second-text">个人信息的使用方式和原因</p>
          <p class="weigh-text">本节阐述了我们使用个人信息的方式和原因。</p>
          <p class="weigh-text">为了产品咨询、销售和行政管理目的</p>
          <p>如果您在线或通过电话对我们、我们的产品或服务咨询相关问题，在您与我们订立合同前，我们将使用您的个人信息答复这些问题，或者应您的要求采取其他措施。</p>
          <p>如果您已购买或注册购买我们的任何产品或服务（包括试用购买），我们将使用您的个人信息（包括银行或银行卡信息）向您提供产品或服务，与您沟通有关产品或服务的问题，处理支付事宜，追索任何债务。</p>
          <p class="weigh-text">为了电话培训监控和质量监控目的</p>
          <p>当我们的销售代表通过电话与您沟通时，我们可能出于培训和监控目的对通话内容录音。</p>
          <p class="weigh-text">为了展会和展览管理目的</p>
          <p>如果您以发言人、赞助商、参展商或参加人员的身份参加展会，我们将在管理展会、处理支付事宜和追讨债务时使用您的个人信息。</p>
          <p>我们还将使用您的个人信息维护数据库，该等数据库能让我们评估您作为发言人或赞助商/参展商的品质、推广展会以及鼓励更多的人参加展会。</p>
          <p>此外，我们可以对展会的参加人员、发言人、赞助商或参展商进行拍照和摄影。我们实施上述行为的，将在相关数据保护法允许的范围内，为推广目的使用这些照片和视频。</p>
          <p>如果展会和展览使用参展证扫描技术，我们将在展会的某些进入地点，如VIP区域、研讨会会场、进出区域和其他区域，使用您的个人信息来识别您的身份。此种情况下我们将获得您的某些定位信息。参展证无法远程读取。</p>
          <p>通过参展证扫描获得的个人信息将被用于入场控制、安全和分析参展人员人流量等目的，以改善参展人员和其他人的展会体验。</p>
          <p>您还可以允许展会的参展商扫描您的参展证。如果您同意参展商扫描，参展商将知悉您的联系信息，并根据相关数据保护法、参展商的隐私政策，以及您在参加展会时收到的其他告知书或给予的同意，使用您的联系信息。</p>
          <p>如果我们主办和管理线上展览或展会，主办方（和代表我们行事的任何第三方平台提供者）将使用您在注册时提供的个人信息，以主办和管理线上展会，分析参展人员的互动情况与人流量，从而改善参展人员的展会体验，为您打造个性化的参展体验。</p>
          <p>当您进入线上展会空间、区域或展厅（如展台）时，赞助商和参展商可以分享您的个人信息，与您交流互动，但需遵守在您注册和登录时向您发出的参展人员隐私告知书。</p>
          <p class="weigh-text">为了营销目的</p>
          <p>我们可以使用您的个人信息，向您发送简报、优惠商品信息或其他营销邮件，让您实时了解您可能感兴趣的我们的发展动态、展会和产品。根据您与我们互动的性质和相关数据保护法，您可以主动同意（即选择接收）我们向您发送营销信息，或者我们有权依据您的默示同意或合法利益向您发送此类信息。您可以在此后选择不接收营销信息，并有权随时改变您的营销偏好（参见“您的权利”一节）。</p>
          <p>我们的一些展会、产品和推广由第三方参展商或赞助商共同拥有品牌或提供赞助。我们会与这些第三方合作伙伴分享您的个人信息。在这种情况下，我们会根据相关数据保护法的规定，向您发出明确的通知，让您有选择同意或不同意分享的机会。第三方合作伙伴将根据相关通知及其隐私政策使用您的个人信息，该等使用行为不受本隐私政策的规范。</p>
          <p class="weigh-text">为了客户和潜在客户管理（包括分析和产品管理）目的</p>
          <p>您的个人信息在与我们依法获取的和我们与第三方共享的其他个人信息或从公开渠道获得的数据整合后，可能被用于让我们更好地了解客户及其偏好、改善我们的产品和服务之目的。这种情况下，我们可能使用自动分析和活动管理技术。</p>
          <p>为了提供即将举行的展会或推出的新产品信息，确保您仅接收与我们的产品和服务有关的广告信息，我们还可以使用数据在微信公众平台和微博等社交媒体上发布广告。</p>
          <p class="weigh-text">为了移动应用和网站分析目的</p>
          <p>我们可以将使用跟踪技术（无论您是否登录网站）所收集的访客会话信息或其他信息与可识别个人身份的信息整合，以了解、分析您的在线体验，确定哪些展会、产品和服务可能引起您的兴趣。</p>
          <p>如果您同意使用您的定位数据，在您使用某些移动应用时，这些应用可以利用定位数据帮助您对展会导航，向您推荐参展商和赞助商的产品。</p>
          <p>我们的营销电子邮件含有单个、唯一的广告“网络信标像素”，能告诉我们邮件是否被打开。这种技术与其他技术结合使用后，能核实邮件内任何对链接的点击。我们使用上述信息实现多种目的（包括确定哪些邮件更让您感兴趣），询问那些没有打开邮件的用户是否希望继续接收邮件。当您删除邮件后，网络信标像素也将被删除。</p>
          <p>如果您订购在线服务，相关电子邮件同样会包含一个网络信标像素。我们跟踪您与这些邮件和在线服务的互动情况，以便进行认证，验证您的展会参与资格，帮助我们确定您对哪些信息感兴趣，在我们的网站上向您推送定制化广告。</p>
          <p>如果您不希望将网络信标像素下载到您的设备上，您应当选择不点击我们向您发送的链接，或者选择不接收营销邮件或不参加在线展会。此类信息可能与您的个人身份相关联。</p>
          <p>虽然在您使用我们的网站和移动应用时，我们尽力向您提供选择，但我们不承诺我们能够接收或遵循网页浏览器“不跟踪”信号。</p>
          <p class="weigh-text">在微信群组、在线会员社群、公告栏和聊天区域内</p>
          <p>您可以选择加入官方企业微信号组织的微信群，参加我们网站上的在线会员社群，在我们的网站上创建、发布个人主页和其他信息。这些社群向您提供了隐私控制设置，您可以选择在多大程度上公开或与社群内的其他人分享您的个人主页和其他信息。</p>
          <p>通常情况下，您可以在编辑个人主页的页面上找到隐私控制设置。您需要了解隐私控制的设置方式（包括默认设置），选择以何种方式分享和保护您提供的信息。您加入微信群组、参加在线会员社群，即表示您同意其他参加者可以利用您提供的信息与您联系。</p>
          <p>如果您在本网站上或因使用本网站而跳转到的其他网站或平台上的社群、微信群或聊天区域披露您的个人信息，浏览这些社群、微信群或聊天区域的其他人可能收集、使用您的个人信息。这会导致社群的其他参加者或相关方在未经您要求的情况下向您发送信息。此种情形超出了我们的控制和责任范围。此外，您自愿分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎的考虑，是否在使用我们的服务时共享甚至公开上传相关信息。</p>
          <p>如果您在客户咨询聊天区域、微信群或聊天区域与我们互动，我们会使用您提供的任何信息帮您推荐产品和/或协助确认您希望订立的订单。</p>
          <p class="weigh-text">为了咨询目的</p>
          <p>“联系我们”的页面上提供的个人信息，仅用于回复或答复相关要求或问题咨询。这些信息不会添加到我们各运营部门的营销或潜在客户数据库中。</p>
          <p class="weigh-text">为发布新闻快讯目的</p>
          <p>我们在您申请订阅新闻快讯时所收集的信息，仅用于我们向您提供新闻快讯服务，了解订阅者的背景和兴趣。</p>
          <p>在提供这项服务时，我们会使用行业标准技术（包括图片下载技术）收集邮件打开数量的统计数字。这将帮助我们监控并改进新闻快讯的服务质量。我们仅在汇总层面上收集、分析此类信息。</p>
          <p>在获得您的许可后，我们可以随时使用您的注册信息联系您，以了解新闻快讯的服务质量。您可以使用邮件中的链接，随时设置拒绝接受此项服务。</p>
          <p class="weigh-text">为了自动决策（包括数据分析）目的</p>
          <p>我们使用全面自动算法技术，依据您明确和/或默示表现出的兴趣，为您展示个性化动态网页内容。我们仅出于向您提供相关度更高的体验之目的，进行一般数据分析，如市场细分分析。我们使用自动决策技术的方式不会产生法律影响或类似重大影响。</p>
          <p>我们在使用这些技术时，会采取措施以避免法律上有歧视性的偏见和误差。这些自动过程可能导致我们向您推送不同的内容。</p>
          <p class="weigh-text">为了履行法律义务（包括反欺诈措施和筛选义务、Covid-19防疫和治安管理）目的</p>
          <p>此外，为了预防欺诈，我们及其他组织还需要根据相关法律法规和最佳做法，随时读取、使用某些个人信息。如果您向我们提供错误或不准确的信息，且我们发现或怀疑任何欺诈行为，我们可以向反欺诈机构提供相关信息，反欺诈机构或我们还可以保存这些信息。</p>
          <p>为了遵守国际贸易制裁法律法规，我们将按照美国、美国财政部海外资产控制办公室、国际清算银行、联合国、欧盟和英国列出的制裁名单筛选某些客户和供应商。</p>
          <p>为了遵守中华人民共和国的防疫要求，我们在线下展会将收集参展人员的身份证件信息（中国身份证、护照及其他身份证件信息），并向中国公安部门和相关防疫部门提供。中国公安部门和相关防疫部门或我们还可以保存这些信息。</p>

          <p class="second-text">我们保护个人信息的方式</p>
          <p class="weigh-text">我们认同保护和管理个人信息的重要性。我们将履行最严格的防范和安全义务，处理您向我们提供的任何个人信息。本节将说明我们采取的某些安全措施。</p>
          <p>我们使用各种物理和技术措施保护个人信息的安全，防止任何人未经授权读取、使用或披露个人信息。电子数据和数据库存储在安全的计算机系统中，这些系统采用物理和电子方式控制信息读取。我们对员工进行数据保护培训，制定了一系列详细的安全和数据保护政策，并要求员工在处理个人信息时遵守这些政策。</p>
          <p>虽然我们采取一切合理措施来确保个人信息的安全，防止他人未经授权读取信息，但我们无法保证在您向网站或其他服务机构转移数据时个人信息的安全性。我们使用 HTTPS （即安全超文本传输协议），通信协议据此通过传输层安全 （TLS） 进行加密，通过计算机网络进行安全通信。我们的网站通过 HTTPS 加载，由网页浏览器中的锁定图标表示，确保传输安全，并提供由官方安全证书机构向网站运营控制人颁发的证书。</p>
          <p>在使用我们的网站、平台或微信小程序进行贸易往来时，您不可避免的要向潜在的交易方披露自己的个人信息，请您妥善保护个人信息，尽在必要情形下向他人提供。如您发现自己的个人信息遭到泄露，请立即联系我们的客服。</p>

          <p class="second-text">个人信息跨境转移</p>
          <p>原则上，您的个人信息将在中华人民共和国境内被处理。然而，作为一家全球公司，您的个人 信息可能会被提供给英富曼关联公司（包括在中华人民共和国境外设立的公司），以实现全球管理和业务规划。对于此类跨境传输，我们将获得您的单独同意，并满足适用中国法律所规定的要求和流程。</p>
          <p>在某些情况下，我们也可能使用中国境外的服务提供商协助我们处理您的个人信息。我们将依法采取必要的措施，包括但不限于获得您的单独同意、确保传输符合中国适用法律规定的要求和流程等。我们将在具体的产品、服务和活动的相关页面另行提供个人信息跨境传输的更多信息，并就此征求您的单独同意。</p>
          <p>如果对上述个人信息的跨境处理活动有任何问题、意见、建议或投诉，您可以通过本声明或集团隐私政策所列的联系方式与我们进行联系或联系境外接收方。</p>

          <p class="second-text">Cookies</p>
          <p>Cookie 是一个小文本文件，其中包含一个唯一的标识符，当用户访问网站时，该标识符会自动放置在用户的计算机或其他设备上。通常，用户可以根据相关供应商在以下链接中作出的说明控制和/或修改浏览器设置来禁用cookie：</p>
          <div class="queue-box">
            <p>— <span class="underline-text weigh-text">Internet Explorer</span></p>
            <p>— <span class="underline-text weigh-text">Mozilla Firefox</span></p>
            <p>— <span class="underline-text weigh-text">Google Chrome</span></p>
            <p>— <span class="underline-text weigh-text">Apple Safari</span></p>
            <p>— <span class="underline-text weigh-text">Opera</span></p>
          </div>

          <p class="second-text">第三方链接</p>
          <p>本网站含有跳转到其他网站的链接。我们对这些网站的隐私处理并不负责，也不接受任何与这些网站的内容相关的责任。我们建议您浏览从本网站链接的每个第三方网站的隐私政策，以确定是否允许其使用您的个人信息。</p>

          <p class="second-text">与哪些人分享个人信息</p>
          <p class="weigh-text">为了向您提供产品和服务，我们可以基于特定理由分享您的信息。本节将阐述我们分享个人信息的方式和理由。</p>
          <p>按照个保法要求，我们只会在单独征得您的同意，或法律法规规定不需要征得您的同意的情况下，才会共享您的个人信息。</p>

          <p class="weigh-text">与关联方分享信息</p>
          <p>我们会与关联方分享个人信息。</p>
          <p>如果我们将与中国大陆境外的关联公司共享个人信息，我们还将确保该等共享符合“个人信息跨境转移”一节中所载明的前提条件与程序。我们仅在必要时共享个人信息，在本政策所述目的范围内，如果我们与关联公司分享您的敏感个人信息，或者我们共享个人信息的关联方改变了个人信息处理的目的和/或方式，我们将再次征求您的授权同意。</p>
          <p>我们将通过制度、协议和技术手段控制您的个人信息在分享时传输和处理的安全性。</p>

          <p class="weigh-text">与服务商分享信息</p>
          <p>我们可能与协助提供产品和服务以及管理我们业务的第三方分享您的个人信息。这些第三方包括 IT 和营销技术主机供应商、网站和数据托管提供商、邮寄公司、广告服务器、物流和一般服务承包商、收债机构、现场健康和安全合作伙伴、展会注册合作伙伴、销售平台提供商、通信工具提供商、展台设计者/搭建者/安装者、赞助/营销/公关资料的供应商和其他展会合作伙伴。只有在第三方需要向您提供我们的产品和服务的情况下，我们才会与第三方共享个人信息。</p>
          <p>特别的，为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴（包括微信公司、网上银行或第三方支付平台等）的应用程序接口（API）和软件工具开发包（SDK）或其他类似的应用程序。我们会对授权合作伙伴获取有关信息的API和SDK进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，要求其按照适用的法律法规、本政策以及其他任何相关的保密和安全措施来处理个人信息。授权合作伙伴单独取得您同意的除外。</p>
          <p>我们使用网络聊天服务，与您建立联系，快速、直接回答有关销售和客户服务的问题。我们确保这些服务商保护您的数据，聊天的目的在于仅快速回答基本服务问题，建议您不要在聊天时提供任何敏感信息，如银行或信用卡信息。</p>
          <p>这些数据处理人有义务遵守合同义务，从而保护您向我们提供的个人数据。</p>

          <p class="weigh-text">与其他组织分享信息</p>
          <p>我们可能会根据当地数据保护法与受信任的合作伙伴组织共享您的个人信息，以用于其营销目的，并在需要时获得您的许可。 </p>
          <p>如果您使用我们的任何虚拟产品，如线上展览、目录网站或网络研讨会，或选择允许我们在展会上扫描您的参展证，我们可以将您提供的信息传递给第三方。通常信息传递将在以下过程中完成：您以用户的身份访问第三方或与第三方互动，例如访问在线展览的展台、扫描您的参展证或点击由第三方提供的品牌资产。在某些情况下，您可以在商品展示网站上直接联系供应商或参展商，他们随后可能会与您联系。在其他情况下，如果我们的虚拟产品由他人赞助，数据将提供给赞助商。通常，如果产品获得赞助，我们会在收集信息时通知您。</p>
          <p>如果我们确定您违反了法律法规或严重违反了您签约平台的相关协议和规则，我们也可能会共享您的个人信息或商业信息，以保护其他用户的人身财产安全不受侵害。 </p>
          <p>我们可能会与第三方共享个人信息的大数据分析，当这些信息经过统计处理，因此无法与个人身份相关联时。</p>

          <p class="weigh-text">为了重组或改变业务目的</p>
          <p>如果我们需要谈判以便向第三方出售全部或部分业务，或者将我们出售给向第三方，或者正在进行重组的，我们可能需要在尽职调查过程中，向第三方或其顾问转移您的全部或部分个人信息。我们会通过和这些主体签署保密协议以要求对您的个人信息采取合理的保密措施。</p>
          <p>转移给重组后的实体或第三方的任何信息都将用于本政策中规定的相同目的，或者用于分析任何拟议销售或重组的目的。第三方变更原先的处理目的、处理方式的，也将重新取得您的同意。</p>

          <p class="weigh-text">为了履行法律或法规义务</p>
          <p>为了遵守法律法规的规定，回应监管机构的要求，我们可以处理您的个人信息。这包括向第三方、法院和/或监管机构或执法机构披露您的个人信息，在全球范围内回应这些机构的询问、诉讼或调查，或者在需要时披露您的个人信息。</p>
          <p>在某些情况下，如果法院、公安部门、其他司法或执法机构或政府实体要求我们提供个人信息，我们可能需要根据法律规定披露您的个人信息。</p>

          <p class="second-text">信息保留的时间</p>
          <p class="weigh-text">我们仅在必要期间或相关法律许可的期间保留个人信息。</p>
          <p>如上文所述，我们在使用个人信息的期间保留个人信息。我们可以在停止使用后出于某些合法商业目的继续使用信息。例如，如果您选择不再接收我们的营销信息，我们将仅保留与您有关的有限资料，确保我们满足您不接收信息的要求。此外，为了遵守法律规定，保护或行使我们的合法权利，我们也可以继续保留您的个人信息。</p>
          <p>在确定适当的个人信息保存期时，我们会考虑个人信息的数量、性质和敏感性，未经授权使用或披露您的个人信息可能带来的风险，我们处理您的个人信息的目的和我们是否可以通过其他方式实现这些目的，以及适用的法律要求，包括但不限于《中华人民共和国个人信息保护法》和《中华人民共和国电子商务法》等。在上述保存期届满后，除非获得您的明确同意，我们会删除您的相关个人信息，或者对其实施匿名化。</p>

          <p class="second-text">您的权利</p>
          <p>如果您对我们使用您的个人信息有任何问题，请联系我们。在某些条件下，您（或在有限的情况下，您的近亲属）有权要求我们采取以下措施：</p>
          <div class="queue-box">
            <p>● 向您提供我们使用您的个人信息的更多具体情况</p>
            <p>● 向您提供您已提供给我们的信息内容副本</p>
            <p>● 更新个人信息中不准确的地方</p>
            <p>● 删除我们没有合法依据使用的个人信息</p>
            <p>● 删除任何个人信息，如果我们收集或使用个人信息违反相关法律或我们与您的协议</p>
            <p>● 停止向您进行直接营销的行为</p>
            <p>● 要求将您的个人信息传输到另一个人信息处理者</p>
            <p>● 限制或拒绝他人处理个人信息</p>
          </div>
          <p>如果您希望行使上述任何权利，请联系我们。本政策结尾处载有我们的联系信息。</p>
          <p>出于安全考虑，我们可能会在处理您的请求之前验证您的身份。在核实您的身份后，我们将及时响应您的请求，并在法律法规规定的期限内给予答复和合理解释，或告知您解决争议的外部途径。 </p>

          <p>但是，在某些情况下，我们可能无法响应您的请求，例如与以下情况相关的请求：</p>
          <div class="queue-box">
            <p>— 我们履行法律法规规定的义务</p>
            <p>— 国家安全、国防和安全</p>
            <p>— 公共安全、公共卫生或重大公共利益</p>
            <p>— 刑事调查、起诉和审判</p>
            <p>— 恶意或滥用权利的证据</p>
            <p>— 保护您或其他个人的生命、财产等重大合法权益</p>
            <p>— 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的问题</p>
            <p>— 商业秘密</p>
          </div>

          <p>当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。</p>
          <p>您在行使上述权利时，要受到某些保护公共利益（如预防或发现犯罪行为）和我们的利益（如行使合法权利）的豁免规定的限制。如果您行使任何这些权利，我们将审查您是否享有这些权利，在多数情况下，我们将在一个月内作出回应。</p>

          <p class="second-text">更新您的信息和营销偏好</p>
          <p>我们希望确保您一直控制您的个人信息。我们尽力确保您的个人信息为准确、最新的信息。我们将始终为您提供取消订阅或不再接收营销信息的选择。</p>
          <p>我们向您发送的电子邮件将说明取消订阅或选择不再接收营销信息的方式。但是，如果您在任何阶段希望更新和/或改正个人信息，或者选择不再接收营销信息，请向我们发送电子邮件提出您的要求，邮箱地址：groupdpo@informa.com</p>

          <p class="second-text">联系我们</p>
          <p class="weigh-text">如果您对本隐私政策有任何疑问，请联系：</p>
          <p>Informa PLC 的集团数据保护官</p>
          <p>地址为：5 Howick Place, London, SW1P 1WG。</p>
          <p>邮件：groupdpo@informa.com</p>
          <p>我们希望我们能解决您关注的任何隐私问题。但是，您始终有权在上海百文会展有限公司的注册地址所在地有管辖权的法院起诉，或者向您所在国家负有隐私法执法权的任何监管机构或其他政府机构投诉。</p>

          <p class="weigh-text">本隐私政策的变更</p>
          <p>为了顺应不断变化的法律、最佳做法和个人信息处理方式的变化，我们可以通过在本网站上发布修订版来随时修订本隐私政策。如果本隐私政策有任何重大变动，我们将通过电子邮件、我们的网站或其他方式发布通知。如要了解最新变更内容，请定期查看。请您确认，在我们发布或发送有关我们对本隐私政策变更的通知后，您继续使用我们的产品或服务，意味着您同意从本隐私政策变更生效之日起，我们可以根据更新后的隐私政策收集、使用和分享您的个人信息。</p>
          <p>本隐私政策的最近更新日期为2022年12月28日。</p>

          <!--          <h2>参观人士条例及规则</h2>-->
          <!--          <h3>1、条例及规则</h3>-->
          <!--          <p>参观人士在登记参观展览或接受许可参观展览时﹐即表示他们同意遵守展览对参观人士的条例及规则和展览中心制定的条例及规则 , 参观人士可向主办单位索取条例及规则副本。</p>-->
          <!--          <h3>2、在展览中心的操守</h3>-->
          <!--          <p>参观人士不得造出或容许造出可引致混乱﹐滋扰﹑烦扰﹑不便﹑伤害或危害他人身体或财物的事情﹐或者是主办单位认为与一般展览规则不相符的事情﹐或者是构成违反条例及规则或相关法律和条例的事情。-->
          <!--          未经主办单位事先书面批准﹐参观人士不得携带照相机﹑摄像机或其它任何形式的录像设备进入展览中心。主办单位有权随时搜查任何参观人士的随身携带物。-->
          <!--          在出席展览其间﹐未经主办单位事先书面批准﹐明确禁止参观人士录制任何制式的影像。该项禁止包括但并不限于﹕任何形式的拍照﹑摄录或数码摄录及绘图或画草图。参观人士同意在被要求时向主办单位交出录有影像的任何性质形式的违规材料﹐包括但不限于﹕胶片﹑录像带﹑草图本﹑照相手机和数码存储设备。-->
          <!--          若参观人士违规录制任何影像﹐影像创作和录制方面的版权和其它知识产权﹐或其它权利（为免生歧义﹐包括录音和广播的权利）（ “知识产权”）﹐不管是现在还是将来产生的权利﹐都将无条件并立即归属主办单位所有。-->
          <!--          参观人士保证按主办单位要求签署所有的契约和文件及采取一切行动﹐以便将知识产权归属主办单位﹐包括但不限于﹕递交原始影像或拷贝的存储媒介。对违反展览和展览中心条例及规则﹑相应法律和条例的参观人士﹐主办单位有权 单方面拒绝任何参观人士入场﹐或要求其离开展览中心。在此问题上﹐主办单位具有最终判断权。</p>-->
          <!--          <h3>3、责任</h3>-->
          <!--          <p>主办单位对参观人士在展览中心及其附近对自身或他人财物所发生的损失或损坏（无论何种原因）﹐不承担任何赔偿责任﹐也不对参观人士在展览中心和离开展览中心的过程中发生的死亡或伤害事故承担任何责任（不包括由于主办单位超过法律限定范围内（仅此范围内）的疏忽所引起的死亡和伤害）。-->
          <!--          参观人士同意主办单位对参展商在展览会中展示或销售的产品不承担任何责任。-->
          <!--          参观人士同意向主办单位、其员工、代理人及承包商 赔偿并免其蒙受由于参观人士自身或其代理的任何侵权行为或未经允许录制影像而导致主办单位自身或其代表蒙受或向其提出的一切申索﹑责任﹑损失﹑诉讼﹑程序﹑赔偿﹑判决﹑支出﹑费用（包括法律费用）及收费等任何损失。-->
          <!--          参观人士同意﹐主办单位对展会官方手册﹑或其它推广材料﹑印刷材料中提供的与参展商或参展产品相关的信息中的错误或遗漏﹐或者是由主办单位或参展商提供的信息中的错误或遗漏不承担任何责任。-->
          <!--          参观人士确认和同意，主办单位、其员工及承包商可以对展会进行拍照/摄像，并可包括出席展览之参观人士的肖像（“影像”）。参观人士在此同意免费授予主办单位及其分支机构于全球就该影像之许可使用权(及授与他人使用之再许可权)，该授予之权利是无限制的、不可撤销的、 永久的、全球性的、免版税和可转让的。参观人士确认，主办单位是该影像所有权利的唯一拥有者，并特此放弃（一）就该影像之任何及所有权利，及（二）就该影像或使用该影像所产生和与之相关之任何及所有索偿的主张。-->
          <!--          除非有主办单位提供其任一董事签名的书面确认﹐否则主办单位不免除条例及规则中之任何规定﹐或其任何权利。</p>-->
          <!--          <h3>4、主办单位隐私政策声明</h3>-->
          <!--          <p>主办单位十分重视个人隐私。主办单位将遵守适用的个人资料保护法律，包括有关个人资料保护的适用中国法律法规。 </p>-->

          <!--          <h4>(1)信息收集</h4>-->
          <!--          <p>为向参观人士提供更好的服务并满足下段所载的目的，主办单位可以在参观人士登记或告知某些信息时收集该等信息。在此过程中，主办单位还可收集公司的个人联络人或公司雇员的个人信息。如登记表中所载，某些要求提供的信息是强制性的，某些则由参观人士自愿提供。如果要求提供但没有提供特定强制性信息，主办单位可能无法提供所需的服务。主办单位仅出于下段所载目的保留个人资料。 </p>-->

          <!--          <h4>(2)信息的使用</h4>-->
          <!--          <p>主办单位可将信息用于以下目的：</p>-->
          <!--          <p>● 处理主办单位展览会展览或参观申请；</p>-->
          <!--          <p>● 通过将个人资料纳入其数据库促进并改善其运营，并根据个人资料进行分析、研究和审计；</p>-->
          <!--          <p>● 向参观人士推广并告知其在中国和世界各地的展览会及其附属公司和合资伙伴组织的活动或展览会；</p>-->
          <!--          <p>● 发送其公司的出版物和研究资料；</p>-->
          <!--          <p>● 营销其服务或产品；</p>-->
          <!--          <p>● 如果需要，进行法律程序的需要，包括收取逾期款项。</p>-->
          <!--          <p>主办单位可将参观人士的个人资料（包括其姓名 /名称、电子邮件地址及实际地址）用于为其在中国和世界各地的展览会或其附属公司和合资伙伴组织的活动或展览会的 宣传 和邀请以及通过传真、电子邮件、直邮、电话及其他通讯方式开展的服务推广进行直接促销，或向参观人士发送电子通讯。 </p>-->

          <!--          <p>本人同意就本人在展览会中选择的参展商及供应商对本人的入场证进行扫描，并愿意向其提供本人的个人数据。本人同意前述个人数据可用于参展商及赞助商就其产品或服务与本人进行联络，并同意参展商及赞助商为上述目的而将数据转移至 中国以外的地区。同时，为经营展览会、分析访客流量及改善访客的活动体验所需，本人理解并同意由主办单位和任何代表其利益的第三方持有并使用本人的个人数据。</p>-->

          <!--          <h4>(3)数据披露/传输 </h4>-->
          <!--          <p>主办单位将对主办单位所持有的个人资料保密，但可以将个人资料提供或传输予：</p>-->
          <!--          <p>● 与主办单位业务运作或服务有关的代理、顾问、核数师、承办商、参展商或服务提供商，为促进及加强主办单位的运作，将所收集的个人资料作分析、研究及审计；</p>-->
          <!--          <p>● 主办单位的海外办事处、关联公司、合资伙伴，亦是其他展览的主办单位，目的是为有关主办单位在中国及世界各地主办的展览会的宣传或邀请进行直接促销；</p>-->
          <!--          <p>● 根据中国境内或境外适用法律，主办单位须向其作出披露的人士。</p>-->

          <!--          <h4>(4)数据传至境外</h4>-->
          <!--          <p>主办单位通常会将参观人士的个人资料储存在主办单位位于中国的服务器内，但参观人士同意，主办单位可将参观人士的个人资料转移到主办单位位于中国以外的办事处或关联公司或本声明以上第（ 3）段所列并可能位于海外的人士或实体。 </p>-->

          <!--          <h4>(5)参观人士同意和权利</h4>-->
          <!--          <p>参观人士签署本合同即表示明确同意本条所载的对其个人资料的收集、使用和传输，包括为直接促销而使用并提供其个人资料。 </p>-->
          <!--          <p>参观人士可通过按下述联络信息通知主办单位而选择不接收促销资料，主办单位将停止发送促销资料，而不收取费用。参观人士还可要求主办单位更正其错误的个人资料。 </p>-->

          <!--          <p>电子邮件：[ Visitors@chinabeautyexpo.com]</p>-->
          <!--          <p>为了安全起见﹐以及为了防止和探察犯罪行为﹐参观人士随身携带的提包需要随时接受抽查﹐并在展览中心接受闭路电视录像。 </p>-->
          <!--          <h3>5、政府法律及管辖权</h3>-->
          <!--          <p>本合约受中国的法律管辖。如果双方就本合约或展览会有任可争议或分歧，任何一方可将该争议提交主办单位所在地有关法院进行审理。 </p>-->
          <!--          <p>除非获得书面注明﹐否则主办单位的权利是累加的﹐将不会取代法律权利及补救方法。迟延行使或不行使任何权利不应视为放弃有关权利。</p>-->
        </div>
      </div>
    </div>

    <el-dialog title="绑定手机号码"  width="500px" :close-on-click-modal="false" :show-close="false" :visible.sync="visible">
      <el-form ref="enrollFormRef" :rules="enrollFormRules" :model="enrollForm" class="add-form">
        <el-form-item prop="mobile">
          <el-input v-model.trim="enrollForm.mobile" placeholder="请输入手机号">
            <div slot="prefix" class="mobile-icon">
            </div>
          </el-input>
        </el-form-item>
        <el-form-item prop="msgCode">
          <div class="code-box">
            <el-input v-model.trim="enrollForm.msgCode" class="form-control code" placeholder="请输入验证码">
              <div slot="prefix" class="yzm-icon">
              </div>
            </el-input>
            <div class="get-code" @click="getEnrollCode">获取验证码</div>
          </div>
        </el-form-item>
        <div class="info-footer">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgSrc: '',
      imgUuid: '',
      rulesCheck: true,
      rulesShow: false,
      activeName: 'second',
      loginType: '1',
      count: 0,
      timer: null,
      loginForm: {
        username: '', // 登录名
        password: '', // 密码
        code: '', // 验证码
        imageCode: ''
      },
      loginFormCode: {
        mobile: '',
        imgCode: '',
        imageCode: ''
      },
      checked: false,
      rules: {
        username: [
          {
            required: true,
            trigger: 'change',
            message: '请输入用户名'
          }
        ],
        password: [
          {
            required: true,
            trigger: 'change',
            message: '请输入密码'
          }
        ],
        code: [
          {
            required: true,
            trigger: 'change',
            message: '请输入验证码'
          }
        ]
      },
      codeRules: {
        mobile: [{
          required: true,
          trigger: 'change',
          message: '请输入手机号码'
        }],
        code: [{
          required: true,
          trigger: 'change',
          message: '请输入验证码'
        }]
      },
      ewmCount: 0,
      ewmTimer: null,
      ewmShow: true,
      qrUrl: '',
      websock: null,
      uuid: '',
      visible: false,
      enrollForm: {
        mobile: '',
        msgCode: ''
      },
      enrollFormRules: {
        mobile: {
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        },
        msgCode: {
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }
      }
    }
  },
  created () {
    this.getQrUrl()
    this.getImage()
  },
  destroyed () {
    this.destroyedTimer()
    if (this.websock) {
      this.websock.close()
      this.websock.onclose()
    }
  },
  methods: {
    // 获取验证码
    getImage () {
      this.$http.get('/api/user/image').then((res) => {
        this.imgSrc = 'data:image/png;base64,' + res.data.data.image || ''
        this.imgUuid = res.data.data.uuid || ''
      })
    },
    destroyedTimer () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.ewmTimer) {
        clearInterval(this.ewmTimer)
      }
    },
    async codeLogin (data) {
      let {data: res} = await this.$http.post('/api/user/loginWeChat', data)
      if (+res.code === 200) {
        this.saveStore(res.data, true)
      } else {
        this.$message({
          type: 'error',
          message: res.msg
        })
      }
    },
    emailEnter () {
      this.ewmShow = false
      this.handleClick()
    },
    backEwm () {
      this.ewmShow = true
      this.activeName = 'first'
    },
    handleClick () {
      this.loginForm = {
        username: '', // 登录名
        imageCode: '',
        code: '' // 验证码
      }
      this.loginFormCode = {
        mobile: '',
        imageCode: '',
        code: ''
      }
      this.destroyedTimer()
    },
    // 获取邮箱验证码
    sendEmailCode () {
      if (!this.loginForm.username) return this.$message.warning('请输入邮箱')
      this.$http.post('/api/user/sendEmailCode', {username: this.loginForm.username}).then((res) => {
        if (+res.data.code === 200) {
          this.ewmCount = 60
          if (this.ewmTimer) {
            clearInterval(this.ewmTimer)
          }
          this.ewmTimer = setInterval(() => {
            if (this.ewmCount > 0) {
              this.ewmCount--
            }
          }, 1000)
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    async login () {
      let _this = this
      if (!this.loginForm.username) return this.$message.warning('请输入邮箱')
      if (!this.loginForm.code) return this.$message.warning('请输入邮箱验证码')
      if (!this.loginForm.imageCode) return this.$message.warning('请输入图形验证码')
      await this.$refs.loginForm.validate(async valid => {
        if (valid) {
          if (!this.rulesCheck) return this.$message.warning('请查看及勾选相关隐私协议')
          let {data: res} = await _this.$http.post('/api/user/loginEmailCode', { ..._this.loginForm, uuid: this.imgUuid })
          if (+res.code === 200) {
            this.saveStore(res.data)
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
            this.getImage()
          }
        }
      })
    },
    // 获取手机验证码
    async getCode () {
      if (!this.loginFormCode.mobile) return this.$message.warning('请输入手机号码')
      if (!this.loginFormCode.imageCode) return this.$message.warning('请输入图形验证码')
      let {data: res} = await this.$http.post('/api/user/getVerificationCode', {...this.loginFormCode, uuid: this.imgUuid})
      if (+res.code === 200) {
        this.count = 60
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
          }
        }, 1000)
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
    async loginByCode () {
      let _this = this
      if (!this.loginFormCode.mobile) return this.$message.warning('请输入手机号码')
      if (!this.loginFormCode.imageCode) return this.$message.warning('请输入图形验证码')
      if (!this.loginFormCode.code) return this.$message.warning('请输入手机验证码')
      await this.$refs.loginForm.validate(async valid => {
        if (valid) {
          if (!this.rulesCheck) return this.$message.warning('请查看及勾选相关隐私协议')
          let {data: res} = await this.$http.post('/api/user/loginByCode', {..._this.loginFormCode, uuid: this.imgUuid})
          if (+res.code === 200) {
            this.saveStore(res.data)
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
            this.getImage()
          }
        }
      })
    },
    saveStore (data, isCode = false) {
      sessionStorage.setItem('token', data.token)
      sessionStorage.setItem('userId', data.userId)
      sessionStorage.setItem('name', data.name)
      let menuList = data.menuList
      let routerList = data.routerList
      let authList = data.authList
      // 存储菜单数据
      sessionStorage.setItem('menuList', JSON.stringify(menuList))
      // 存储路由数据
      sessionStorage.setItem('routerList', JSON.stringify(routerList))
      // 权限
      sessionStorage.setItem('authList', JSON.stringify(authList))
      // 存储管理员userId
      sessionStorage.setItem('userId', data.userId)
      // 存储服务商Id
      sessionStorage.setItem('companyId', data.companyId)
      // 提交到store
      this.$store.commit('getMenuList', this.$router)
      if (isCode) {
        const url = window.location.href
        const start = url.indexOf('?')
        window.location.href = url.substring(0, start) + '#/dataHome'
      } else {
        // 登录成功跳转到首页
        this.$router.push('/dataHome')
      }
    },
    async getQrUrl () {
      let {data: res} = await this.$http.get('appletCbe/myChart/getShowQrCode')
      this.qrUrl = res.data.qrUrl
      this.uuid = res.data.uuid
      this.initWebSocket()
    },
    initWebSocket () { // 初始化weosocket
      if (this.websock) {
        this.websock.close()
        this.websock.onclose()
      }
      const wsuri = 'wss://exshow-web.cbebaiwen.com/webSocket'
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen () { // 连接建立之后执行send方法发送数据
      let actions = { 'uuid': this.uuid }
      this.websocketsend(JSON.stringify(actions))
    },
    websocketonerror () { // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage (e) { // 数据接收
      if (!this.rulesCheck) {
        this.$message.warning('请查看及勾选相关隐私协议')
      } else {
        const data = JSON.parse(e.data)
        if (data.code === 1002) {
          this.codeLogin({code: data.uuid})
        }
        if (data.code === 1004) {
          this.uuid = data.uuid
          this.$message.warning(data.msg)
          setTimeout(() => {
            this.visible = true
          }, 500)
        }
      }
    },
    websocketsend (data) { // 数据发送
      this.websock.send(data)
    },
    websocketclose (e) {
      console.log('断开连接', e)
    },
    async getEnrollCode () {
      let {data: res} = await this.$http.post('/api/user/getVerificationCode', {mobile: this.enrollForm.mobile})
      if (+res.code === 200) {
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
    save () {
      this.$refs.enrollFormRef.validate(async (valid) => {
        if (valid) {
          await this.codeLogin({...this.enrollForm, code: this.uuid})
          this.visible = false
          this.enrollForm = {
            mobile: '',
            msgCode: ''
          }
        }
      })
    },
    cancel () {
      this.visible = false
      this.enrollForm = {
        mobile: '',
        msgCode: ''
      }
    }
  }
}
</script>
<style lang="less">
@font-face {
  font-family: 'Alimama ShuHeiTi';
  src: url('../../assets/fonts/AlimamaShuHeiTi-Bold.ttf');
}

.login-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/images/login-background.jpg") no-repeat top left;
  background-size: cover;
  overflow: hidden;

  .wx-code {
    width: 230px;
    height: 230px;
    margin: 0 auto;
    box-shadow: rgba(225, 225, 225, 0.6) 0 0 10px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .sign-content {
    width: 370px;
    margin-top: 216px;
    margin-left: 60%;
    color: rgba(255, 255, 255, 0.95);

    .title {
      margin-bottom: 30px;
      text-align: center;
      font-size: 32px;
      color: #fff;
      font-family: Alimama ShuHeiTi;
    }

    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 60px;
    }

    .el-tabs__item {
      color: #000;
      font-weight: bold;
    }

    .el-tabs__item:hover,
    .el-tabs__item.is-active {
      color: #6da09c;
    }

    .el-tabs__nav-wrap::after {
      display: none;
    }
  }

  .login-info {
    width: 100%;
    height: 10px;
  }

  .login-form {
    box-sizing: border-box;
    width: 100%;
    height: 464px;
    position: relative;
    background-color: #fff;
    border-radius: 20px;
    padding: 30px 10px 10px 20px;
    box-shadow: 0 10px 5px  rgba(225, 225, 225, 0.3);
    .mobile-icon {
      width: 20px;
      height: 20px;
      margin-top: 10px;
      background: url('../../assets/images/mobile.png') no-repeat center;
    }

    .yzm-icon {
      width: 20px;
      height: 20px;
      margin-top: 10px;
      background: url('../../assets/images/yzm.png') no-repeat center;
    }

    .email-icon {
      width: 20px;
      height: 20px;
      margin-top: 10px;
      background: url('../../assets/images/email.png') no-repeat center;
    }

    .ewm-sing {
      position: absolute;
      top: 0;
      right: 0;
      content: '';
      display: inline-block;
      width: 30px;
      height: 30px;
      background: url("../../assets/images/ew-code.png") no-repeat center;
      background-size: 100%;
      cursor: pointer;
    }
  }

  .sign-footer {
    position: absolute;
    left: 0;
    bottom: 30px;
    width: 100%;
    margin: 20px 0;
    padding-top: 15px;
    //border-top: solid 1px rgba(255, 255, 255, .3);

    .footer-text {
      width: 99%;
      font-size: 13px;
      color: #fff;
      text-align: center;
    }
  }
}

.email-title {
  text-align: center;
  color: #000;
  margin-top: 10px;
  margin-bottom: 30px;
  font-size: 14px;
  font-weight: bold;
}

.visit-rules {
  margin-top: 10px;
  padding: 0 20px;

  .rules-text {
    color: #000;
    margin-left: 6px;
    font-size: 12px;
    cursor: pointer;
    font-family: PingFang SC;
  }
}

.rules-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .6);
  z-index: 9999;

  .close-box {
    position: relative;
    height: 40px;
    line-height: 40px;
  }

  .rules-close {
    float: right;
    margin-right: 20px;
    color: #000;
    cursor: pointer;
  }

  .rules-body {
    box-sizing: border-box;
    width: 70%;
    height: 90%;
    padding-bottom: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
  }

  .rules-content {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 50px);
    padding: 0 30px;
    overflow: auto;

    .weigh-text {
      font-weight: 700;
    }

    .queue-box {
      padding-left: 30px;
    }

    .underline-text {
      margin: 20px 0 20px 0;
      text-decoration: underline;
    }

    .second-text {
      margin-top: 40px;
      margin-bottom: 22px;
      font-size: 20px;
    }

    h2 {
      margin-bottom: 20px;
      text-align: center;
    }

    h3 {
      margin-bottom: 16px;
    }

    h4, p {
      margin-bottom: 10px;
    }

    p, h4 {
      text-indent: 2em;
      line-height: 1.6;
      letter-spacing: 1px;
    }
  }
}

.code-box {
  position: relative;
  display: flex;
  align-items: center;

  .get-code {
    position: absolute;
    top: 0;
    right: 20px;
    text-align: center;
    color: #6da09c;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
  }
}

.email-enter {
  margin: 10px 0 10px;
  text-align: center;
  color: #333;
  font-size: 14px;

  span {
    color: #6da09c;
    cursor: pointer;
    font-weight: bold;
  }
}

.codeImg {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue